import { render } from "./HlxTableHead.vue?vue&type=template&id=32d0f1f2"
import script from "./HlxTableHead.vue?vue&type=script&lang=js"
export * from "./HlxTableHead.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__